export default function normalizeDate(date?: Date | string) {
    if (typeof date === 'string') {
        return new Date(date);
    }
    return date || new Date();
}
